import { render, staticRenderFns } from "./ManageSettings.vue?vue&type=template&id=fa719c6c&scoped=true"
import script from "./ManageSettings.vue?vue&type=script&lang=js"
export * from "./ManageSettings.vue?vue&type=script&lang=js"
import style0 from "./ManageSettings.vue?vue&type=style&index=0&id=fa719c6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa719c6c",
  null
  
)

export default component.exports